module.exports = {"420982001":"府城街道","420982002":"南城街道","420982100":"赵棚镇","420982101":"李店镇","420982102":"巡店镇","420982103":"棠棣镇","420982104":"雷公镇","420982105":"王义贞镇","420982106":"烟店镇","420982107":"孛畈镇","420982108":"伏水镇","420982200":"陈店乡","420982201":"辛榨乡","420982202":"木梓乡","420982203":"接官乡","420982400":"开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420982.json
// module id = 1761
// module chunks = 0